import { Pipe, PipeTransform } from '@angular/core';
import { I18NextService } from 'angular-i18next';
import { Billing } from 'mbs-ui-shared@components/components/models/license.model';
import { NAValue } from '../constants/license';

@Pipe({ name: 'billing' })
export class BillingPipe implements PipeTransform {
  constructor(private i18n: I18NextService) {}

  transform(billing: Billing): string {
    if (billing.value.includes(NAValue)) {
      return NAValue;
    }

    if (!billing?.value) return '—';

    return billing?.unitName ? `${billing.value} ${billing?.unitName}` : this.i18n.t('shared:licenses.days', { count: +billing.value });
  }
}
